import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import {
    AppointmentWizardSettingsStore,
    AppointmentWizardSettingsState,
} from './appointment-wizard-settings.store';
import { map } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { FamilyWizardModel } from '../../models/family-wizard.model';
import { FamilyFolderModel } from '../../models/family-folder.model';
import { ServiceWizard } from '../service-wizard/service-wizard.model';
import { CommonWizardService } from '../../../core/services/common-wizard/common-wizard.service';
import { ProductWizard } from '../product-wizard/product-wizard.model';
import { PackWizard } from '../pack-wizard/pack-wizard.model';

@Injectable({ providedIn: 'root' })
export class AppointmentWizardSettingsQuery extends Query<
    AppointmentWizardSettingsState
> {
    constructor(
        protected store: AppointmentWizardSettingsStore,
        private commonWizardService: CommonWizardService
    ) {
        super(store);
    }

    /*-----------*/
    /** GETTERS */
    /*----------*/

    get stepStack() {
        return this.getValue()?.stepStack;
    }

    get families() {
        return this.getValue()?.families;
    }

    get professionals() {
        return this.getValue()?.professionals;
    }

    get selectFamiliesDistinct(): Observable<FamilyWizardModel[]> {
        return this.select('families').pipe(
            map((families) => {
                return this.commonWizardService.getFamiliesCommonFactor(
                    families
                );
            })
        );
    }

    selectFamilyFolderTree(
        familiesWizard$: Observable<FamilyWizardModel[]>,
        servicesWizard$: Observable<ServiceWizard[]>,
        productsWizard$: Observable<ProductWizard[]>,
        packsWizard$: Observable<PackWizard[]>
    ) {
        return this.commonWizardService.selectFamilyFolderTree(
            familiesWizard$,
            servicesWizard$,
            productsWizard$,
            packsWizard$
        );
    }
}
